// todo: join urls correctly
const buildUrl = url => `https://${(import.meta.env.VITE_API_URL + url).replace('https://', '').replace('//', '/')}`

const emptyResponseError = { empty: true }
const hasCaches = typeof caches !== 'undefined' && !!caches
let axios = null

/*
 * Returns a Promise that resolves to an object with the following properties:
 * - data: Cached data, if it exists. Otherwise, data from the network request.
 * - network: Function to refresh data from the network. Updates the cache if successful.
 * - headers: Response headers from the cached data or network request.
 */
const cacheHttp = (url, axiosOptions = {}, cacheName = 'custom') => {
  return new Promise((resolve, reject) => {
    // try cache
    cacheRequest(url, cacheName)
      .then(cacheResult => {
        return resolve({
          ...cacheResult,
          network: () => networkRequest(url, axiosOptions, cacheName)
        })
      })
      .catch(() => {
        // fallback to network
        networkRequest(url, axiosOptions, cacheName)
          .then(networkResult => {
            return resolve({
              ...networkResult,
              network: () => Promise.resolve(networkResult)
            })
          })
          .catch(err => reject(err))
      })
  })
}

const networkRequest = (url, axiosOptions, cacheName) => {
  return new Promise((resolve, reject) => {
    axios.get(url, axiosOptions)
      .then(response => {
        if (!response || !response.data) {
          console.error('response was empty', { response })
          return reject(emptyResponseError)
        }

        saveCache(url, response, cacheName)

        return resolve(response)
      })
      .catch(err => reject(err))
  })
}

export const hasAppCacheForUrl = async (url, cacheName) => {
  if (!hasCaches) return
  const cache = await caches.open(cacheName)
  const fullUrl = buildUrl(url)
  return cache.match(fullUrl)
}

// read cached response
export const cacheRequest = (url, cacheName) => {
  return new Promise((resolve, reject) => {
    if (!hasCaches) return reject(emptyResponseError)

    hasAppCacheForUrl(url, cacheName)
      .then(response => {
        if (!response) return reject(emptyResponseError)
        response.json().then(res => {
          if (!res?.data) return reject(emptyResponseError)
          return resolve(res)
        })
      })
      .catch(err => reject(err))
  })
}

// save new json in cache
export const saveCache = function (url, response, cacheName) {
  if (!hasCaches) return
  caches.open(cacheName).then(async function (cache) {
    const fullUrl = buildUrl(url)

    await cache.put(fullUrl, new Response(JSON.stringify(response)))
  })
}

export const setCacheHttpAxiosInstance = (instance) => {
  if (axios) console.warn('Axios (cacheHttp) instance already set, ignoring new instance')
  axios = instance
}

export default cacheHttp
